/**
 * PromotionListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Pagination,
} from 'components';
import { Button, DatePicker, Input, Radio, Select } from 'antd';
import { stringToMoneyFormat } from 'utils';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const PromotionListPresenter = () => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={'상품명'}
                options={[
                  { label: '상품명', value: '상품명' },
                  { label: '회원명', value: '회원명' },
                  { label: '전화번호', value: '전화번호' },
                ]}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '기간',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                style={{ ...styles.form.input.large }}
                placeholder="혜택등록일"
              />
            </>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '적립금액',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '할인금액',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '쿠폰 발행 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'발행함'}>
                <Radio value={'발행함'}>발행함</Radio>
                <Radio value={'발행 안함'}>발행 안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '프로모션 진행 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'진행함'}>
                <Radio value={'진행함'}>진행함</Radio>
                <Radio value={'진행 안함'}>진행 안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '상품 분류',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={[
                  { label: '대분류1', value: '대분류1' },
                  { label: '대분류2', value: '대분류2' },
                  { label: '대분류3', value: '대분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'대분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '중분류1', value: '중분류1' },
                  { label: '중분류2', value: '중분류2' },
                  { label: '중분류3', value: '중분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'중분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '소분류1', value: '소분류1' },
                  { label: '소분류2', value: '소분류2' },
                  { label: '소분류3', value: '소분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'소분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '상세분류1', value: '상세분류1' },
                  { label: '상세분류2', value: '상세분류2' },
                  { label: '상세분류3', value: '상세분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'상세분류 선택'}
              />
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 10; i++) {
    newData.push({
      프로모션명: '런칭할인',
      프로모션코드: 'JMCOFFEE',
      적립수치: 1000,
      할인수치: 1000,
      쿠폰여부: '-',
      시작일: new Date(),
      종료일: new Date(),
      진행여부: '진행함',
    });
  }
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>프로모션 목록</Title>

          {/* 요약 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <Row gutter={20}>
              <Col x={12}>
                <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                  <div>
                    <div
                      style={{
                        padding: '10px 16px',
                        background: '#E1E2E4',
                        borderTopRightRadius: 4,
                        borderTopLeftRadius: 4,
                      }}
                    >
                      <h4 style={{ fontSize: 13, fontWeight: 500 }}>
                        진행중인 프로모션
                      </h4>
                    </div>
                    <div
                      style={{
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                        background: '#FFFFFF',
                      }}
                    >
                      <Table
                        minHeight={260}
                        columns={[
                          {
                            title: '혜택유형',
                            key: '혜택유형',
                          },
                          {
                            title: '혜택명',
                            key: '혜택명',
                          },
                          {
                            title: '시작일',
                            key: '시작일',
                            render: (item) =>
                              moment(item).format('YYYY-MM-DD HH:mm'),
                          },
                          {
                            title: '종료일',
                            key: '종료일',
                            render: (item) =>
                              moment(item).format('YYYY-MM-DD HH:mm'),
                          },
                        ]}
                        data={[
                          {
                            혜택유형: '기간할인',
                            혜택명: '런칭할인',
                            시작일: new Date(),
                            종료일: new Date(),
                          },
                        ]}
                      />
                    </div>
                  </div>
                </Content>
              </Col>
              <Col x={12}>
                <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                  <div>
                    <div
                      style={{
                        padding: '10px 16px',
                        background: '#E1E2E4',
                        borderTopRightRadius: 4,
                        borderTopLeftRadius: 4,
                      }}
                    >
                      <h4 style={{ fontSize: 13, fontWeight: 500 }}>
                        진행중인 프로모션
                      </h4>
                    </div>
                    <div
                      style={{
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                        background: '#FFFFFF',
                      }}
                    >
                      <Table
                        minHeight={260}
                        columns={[
                          {
                            title: '혜택유형',
                            key: '혜택유형',
                          },
                          {
                            title: '쿠폰명',
                            key: '쿠폰명',
                          },
                          {
                            title: '사용기간',
                            key: '사용기간',
                            render: (item) =>
                              moment(item).format('YYYY-MM-DD HH:mm'),
                          },
                        ]}
                        empty={
                          <p style={{ fontSize: 13, fontWeight: 400 }}>
                            발급중인 쿠폰이 없습니다.
                          </p>
                        }
                      />
                    </div>
                  </div>
                </Content>
              </Col>
            </Row>
          </Content>
          {/* 요약 끝 */}

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 20,
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                  총 <span>0</span>건
                </h4>
                <Button
                  size="large"
                  style={{ marginRight: 8 }}
                  onClick={() => navigate('register')}
                >
                  프로모션 추가
                </Button>
                <Button size="large" style={{ marginRight: 8 }}>
                  선택삭제
                </Button>
              </div>
              <div>
                <Select
                  size="large"
                  value={'등록일순'}
                  options={[
                    { label: '등록일순', value: '등록일순' },
                    { label: '등록일순2', value: '등록일순2' },
                  ]}
                />
              </div>
            </div>
            <Table
              data={newData}
              isChecked
              columns={[
                {
                  title: '프로모션명',
                  key: '프로모션명',
                },
                {
                  title: '프로모션코드',
                  key: '프로모션코드',
                },
                {
                  title: '적립 수치',
                  key: '적립수치',
                  render: (item) => stringToMoneyFormat(item, '원'),
                },
                {
                  title: '할인 수치',
                  key: '할인수치',
                  render: (item) => stringToMoneyFormat(item, '원'),
                },
                {
                  title: '쿠폰여부(쿠폰수량)',
                  key: '쿠폰여부',
                },
                {
                  title: '혜택 시작일',
                  key: '시작일',
                  render: (item) => moment(item).format('YYYY-MM-DD HH:mm'),
                },
                {
                  title: '혜택 종료일',
                  key: '종료일',
                  render: (item) => moment(item).format('YYYY-MM-DD HH:mm'),
                },
                {
                  title: '진행여부',
                  key: '진행여부',
                },
              ]}
              onRow={(d) => navigate(`${d.id}`)}
            />
            <Pagination total={51} style={{ marginTop: 20 }} />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default PromotionListPresenter;
